import { render, staticRenderFns } from "./Grid1.vue?vue&type=template&id=0146ae7f&scoped=true&"
import script from "./Grid1.vue?vue&type=script&lang=ts&"
export * from "./Grid1.vue?vue&type=script&lang=ts&"
import style0 from "./Grid1.vue?vue&type=style&index=0&id=0146ae7f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0146ae7f",
  null
  
)

export default component.exports